import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onChange", "options", "direction", "value", "name", "css", "asChild", "as", "style", "className", "disabled"],
  _excluded2 = ["id", "disabled"];
import React, { createElement as _createElement } from "react";
import RadioButton from "./components/RadioButton";
import { BaseRadioButtonsContainer } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
var RadioButtons = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var onChange = _ref.onChange,
    options = _ref.options,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? "vertical" : _ref$direction,
    value = _ref.value,
    name = _ref.name,
    css = _ref.css,
    asChild = _ref.asChild,
    as = _ref.as,
    style = _ref.style,
    className = _ref.className,
    disabled = _ref.disabled,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(BaseRadioButtonsContainer, _extends({
    onValueChange: onChange,
    orientation: direction,
    value: value,
    name: name,
    ref: forwardedRef,
    disabled: disabled
  }, props, {
    children: options === null || options === void 0 ? void 0 : options.map(function (_ref2) {
      var id = _ref2.id,
        optionDisabled = _ref2.disabled,
        restProps = _objectWithoutProperties(_ref2, _excluded2);
      return /*#__PURE__*/_createElement(RadioButton, _extends({}, restProps, {
        key: id,
        id: id,
        disabled: disabled || optionDisabled
      }));
    })
  }));
});
RadioButtons.displayName = "RadioButtons";
export default RadioButtons;